// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__2XbVF","OrderButton":"BuildControls_OrderButton__3ahzz","enable":"BuildControls_enable__3sCnA"};